export const footer = () => {

    const $footer = document.querySelector('.footer');
    if ($footer) {
        
        const $footerMobileNav = $footer.querySelector('.footer__nav-mobile');
        if ($footerMobileNav) {
            
            //Check for accordions
            const $accordions = $footerMobileNav.querySelectorAll('.accordion-container');

            if ($accordions) {

                $accordions.forEach(($accordion) => {

                    const $accordionHeader = $accordion.querySelector('.accordion-header');
                    const $accordionSVG = $accordion.querySelector('svg.icon--arrow-right');
                    const $accordionBody = $accordion.querySelector('.accordion-body');

                    if ($accordionHeader && $accordionBody) {
                        
                        $accordionHeader.addEventListener("click", () => {

                            if ($accordionBody.classList.contains("hidden")) {
                                $accordionBody.classList.remove("hidden");
                                $accordionBody.classList.add("flex");
                                if ($accordionSVG) {
                                    $accordionSVG.classList.remove("rotate-arrow-right-90-deg");
                                    $accordionSVG.classList.add("rotate-arrow-right-270-deg");
                                }
                            } else {
                                $accordionBody.classList.add("hidden");
                                $accordionBody.classList.remove("flex");
                                if ($accordionSVG) {
                                    $accordionSVG.classList.add("rotate-arrow-right-90-deg");
                                    $accordionSVG.classList.remove("rotate-arrow-right-270-deg");
                                }
                            }            
                        });
                    }
                });
            }
        }
    }
};

export default footer;